import React from 'react';
import { Event } from '../../../../../model/event';
import { Status } from './Status/Status';
import { Ticketcodes } from './Ticketcodes/Ticketcodes';
import { Grid } from '../../../../../components/Grid/Grid';
import { TicketDist } from './TicketsDist/TicketDist';
import { Stack } from '../../../../../components/Stack/Stack';
import { Activities } from '../../../../../components/Activities/Activities';
import { t } from '../../../../../locales/translate';
import { SalesHeatmap } from './SalesHeatmap/SalesHeatmap';
import { SalesOverTime } from './sales_over_time/sales_over_time';
import { SalesByGender } from './sales_by_gender/sales_by_gender';
import { UtmTrackingSourcesCard } from '../../../../../components/product_utm_tracking/utm_tracking_sources_card';
import { UtmTrackingMediaCard } from '../../../../../components/product_utm_tracking/utm_tracking_media_card';
import { UtmTrackingCampaignsCard } from '../../../../../components/product_utm_tracking/utm_tracking_campaigns_card';

interface Props {
  event: Event;
  eventImportantActivitiesKey: number;
}

export function Overview({ event, eventImportantActivitiesKey }: Props): JSX.Element {
  return (
    <div className="event-overview">
      <Stack size="lg">
        <Activities
          className="event-activities"
          title={t.model.event.importantCommentsTitle}
          readOnly
          subjectType="event"
          subjectId={event.id}
          metaFilter="productImportant"
          cacheKey={eventImportantActivitiesKey}
          collapseWhenEmpty
          collapseWhenLoading
        />
        <Status event={event} />
        {(event.status === 'on_sale' || event.status === 'stopped') && (
          <>
            <Grid>
              <Ticketcodes event={event} />
              <TicketDist event={event} />
            </Grid>
            <SalesOverTime title={t.model.sale._plural} saleId={event.id} saleType="product" />
            <SalesByGender saleId={event.id} saleType="product" />
            <SalesHeatmap saleId={event.id} type="product" />
            <UtmTrackingSourcesCard productId={event.id} />
            <UtmTrackingMediaCard productId={event.id} />
            <UtmTrackingCampaignsCard productId={event.id} />
          </>
        )}
      </Stack>
    </div>
  );
}
